// src/services/api.js
import axios from 'axios';

const API_URL = 'https://admin.executivehaven.org/api/all-teams/'; // Update the URL if needed

export const fetchTeams = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data.posts;
  } catch (error) {
    console.error('Error fetching posts:', error);
    throw error;
  }
};
